(function () {
    var controllerId = 'host.views.insurers.createEdit.createEditInsurerPage';
    var app = angular.module('app');
    app.controller(controllerId, [
        function () {
        }
    ]);
})();
